import React from 'react'
import {Button, Col, Container, Image, Row} from 'react-bootstrap'
import styled from 'styled-components'
import {
  ROOT_URL,
} from '../../constants/urls'
import {
  IMAGE_PROFILE,
} from '../../constants/pngs'
import {useNavigate} from 'react-router'
import {localise} from '../../services/LocalizationServices'
import {Helmet} from 'react-helmet'

const AboutMe = () => {
  const history = useNavigate()

  return (
    <div>
      <Helmet>
        <meta charSet='utf-8' name='description' content={localise('SEO.aboutMe.description')}/>
        <meta charSet='utf-8' name='keywords' content={localise('SEO.aboutMe.keywords')}/>
        <title>{localise('SEO.aboutMe.title')}</title>
      </Helmet>
      <Container className='padding-under-nav'>
        <div>
          <div className='header-section mb-1'>
            {localise('about.title')}
          </div>
          <div className='d-flex justify-content-center'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href={ROOT_URL}>{localise('nav.home')}</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {localise('nav.aboutMe')}
                </li>
              </ol>
            </nav>
          </div>
          <div className='homepage-about-title text-center mt-3'>
            {localise('about.tagline')}
          </div>
          <div className='homepage-about-title text-center mt-3'>
            Adv.Dip.Hyp. M.I.C.H.P.
          </div>
        </div>
        <div className='responsive-two-column-grid py-sm-2 py-lg-4'>
          <div className='px-5'>
            <img className='about-img' src={IMAGE_PROFILE} ></img>
          </div>
          <div>
            <div className='about-Subheader'>{localise('about.introTitle')}</div>
              <div className='w-100 mt-4'>
                <div className='about-normal'>{localise('about.introDescription')}</div>
                <br/>
                <div className='about-normal'>{localise('about.introDescription2')}</div>
                <br/>
                <div className='about-normal'>{localise('about.introDescription3')}</div>
            </div>
          </div>
        </div>
        <div className='mb-5'>
          <div className='homepage-about-title text-center mt-5'>{localise('about.howHelp')}</div>
            <div className='w-100 mt-4'>
              <div className='homepage-about-Subheader text-center'>{localise('homepage.aboutHeader')}</div>
            </div>
          <div>
            <div className='about-normal text-center mt-4'>{localise('about.fullDescription')}</div>
            <br/>
            <div className='about-normal text-center mt-4'>{localise('about.fullDescription2')}</div>
          </div>
        </div>
        {/* <Row className='mb-lg-5'>
          <div className='homepage-about-title text-center mt-5'>{localise('about.myValues')}</div>
            <div className='w-100 mt-4'>
              <div className='homepage-about-Subheader text-center'>{localise('about.valuesTagline')}</div>
            </div>
          <div className='mt-4'>
            <div className="card-deck">
              <CardItem 
                image={ICON_HOME} 
                title={localise('about.honesty')} 
                description={localise('about.honestyDesc')}
              />
              <CardItem 
                image={ICON_PENCIL} 
                title={localise('about.learning')} 
                description={localise('about.learningDesc')}
              />
              <CardItem 
                image={ICON_LOCK} 
                title={localise('about.trust')} 
                description={localise('about.trustDesc')}
              />
              <CardItem 
                image={ICON_FLAG} 
                title={localise('about.passion')} 
                description={localise('about.passionDesc')}
              />
              <CardItem 
                image={ICON_EYE} 
                title={localise('about.vision')} 
                description={localise('about.visionDesc')}
              />
              <CardItem 
                image={ICON_STAR} 
                title={localise('about.future')} 
                description={localise('about.futureDesc')}
              />
            </div>
          </div>
        </Row> */}
      </Container>
    </div>
  )
}

export default AboutMe